import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waWithMessage } from "./data";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waWithMessage("Hello KARM INDUSTRIES, I have an enquiry about your bio pellets.")}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chat with KARM INDUSTRIES on WhatsApp"
    initial={{ opacity: 0, scale: 0 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2, type: "spring", stiffness: 260, damping: 18 }}
    className="pulse-ring fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-[#050B07] shadow-2xl transition-transform duration-300 hover:scale-110"
  >
    <MessageCircle className="h-7 w-7" />
  </motion.a>
);
